import React, { useEffect, useRef } from "react";
import { MyGlobalContext } from "../../Context";
import {MdManageSearch} from "react-icons/md";


const Search = () => {
  const { setSearchInput } = MyGlobalContext();
  
  // const inputRef = useRef(null);
  const HandleOnChange = (e) => {
    setSearchInput(e.target.value);
  };
  const HandleOnSubmit = (e) => e.preventDefault();
  // useEffect(() => {
  //   inputRef.current.focus();
  // }, []);

  return (
    <section className="">
      <div className="form-label mt-4">
        <label htmlFor="label">
          Search favorite cocktails & Choose types
        </label>
      </div>
      <form onSubmit={HandleOnSubmit} className="search-form btn-src-flex relative">
      <input 
      type="text" 
      onChange={HandleOnChange} 
      // ref={inputRef} 
      placeholder="Search your cocktails" className="input-search-form" />
      <p className=" absolute top-[30px] right-[10%] md:right-[22%] text-[25px] text-[rgb(255,255,255)]"><MdManageSearch /></p>
    </form>
    </section>
  );
};

export default Search;
